module.exports = __webpack_public_path__ + "static/media/ps.74d462ee.svg";